<template>
  <div class="modal">
    <form id="supporter-details" class="card w-modal h-modal">
      <div class="header">
        <div class="title">
          <div class="flex flex-col">
            <h1 class="ml-2">Details</h1>
          </div>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <!-- Donation -->
        <div class="field">
          <h2>Donation</h2>
          <div class="row mt-2">
            <div class="field">
              <label>Date</label>
              <input type="text" disabled :value="formatDate(payload.donation.donationDate)" />
            </div>
            <div class="field">
              <label>Lastest Transaction Date</label>
              <input type="text" disabled :value="formatDate(payload.createdAt)" />
            </div>
          </div>
          <div class="field">
            <label>Amount</label>
            <input type="text" disabled :value="'A$' + payload.donation.amount" />
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>Payment Type</label>
              <input type="text" disabled :value="getPaymentType()" />
            </div>
            <div class="field">
              <label>Donation Type</label>
              <input type="text" disabled :value="payload.donation.type" />
            </div>
          </div>
          <div
            v-if="payload.transaction.rawResponse && payload.transaction.rawResponse.CardHolderName"
            class="row mt-2"
          >
            <div class="field">
              <label>Card Holder Name</label>
              <input type="text" disabled :value="payload.transaction.rawResponse.CardHolderName" />
            </div>
          </div>
          <div v-if="payload.transaction.rawResponse && payload.transaction.rawResponse.TruncatedCard" class="row mt-2">
            <div class="field">
              <label>Masked Credit Card</label>
              <input type="text" disabled :value="payload.transaction.rawResponse.TruncatedCard" />
            </div>
            <div class="field">
              <label>Expiry Date</label>
              <input
                type="text"
                disabled
                :value="payload.transaction.rawResponse.ExpM + '/' + payload.transaction.rawResponse.ExpY"
              />
            </div>
          </div>
          <div class="row mt-2" v-if="payload.transaction.receiptNumber">
            <div class="field">
              <label>Receipt Number</label>
              <input type="text" disabled :value="payload.transaction.receiptNumber" />
            </div>
            <div class="field">
              <label v-if="payload.donation.packageCode">Package Code</label>
              <input v-if="payload.donation.packageCode" type="text" disabled :value="payload.donation.packageCode" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>Payment Status</label>
              <div class="mt-3">
                <div class="flex" v-if="transactionStatus && transactionStatus.toLowerCase() === completed">
                  <img class="h-5 mr-2" src="@/assets/img/tick_icon.svg" />
                  <div class="flex flex-row">Success</div>
                </div>
                <!-- Resend Receipt -->
                <button
                  v-if="
                    transactionStatus &&
                    transactionStatus.toLowerCase() === completed &&
                    !showResendReceiptInput &&
                    canEdit
                  "
                  class="secondary mt-2"
                  type="button"
                  @click="
                    showResendReceiptInput = true;
                    message = null;
                  "
                >
                  Send {{ payload.donation.type === 'Single' ? 'Receipt' : 'Confirmation' }}
                </button>
                <div class="mt-4" v-if="showResendReceiptInput">
                  <form id="send-receipt">
                    <!-- Radio buttons to choose supporter's email or different email -->
                    <div v-if="payload.supporter.email" class="flex flex-col py-2 px-4 border-2 border-dotted gap-y-2">
                      <label class="flex flex-row items-center">
                        <input
                          class="mr-4"
                          id="supporterEmail"
                          type="radio"
                          value="supporterEmail"
                          v-model="selectReceiptEmail"
                          @change="updateReceiptEmail()"
                        />
                        Send to the supporter's email: {{ payload.supporter.email }}
                      </label>
                      <label class="flex flex-row items-center">
                        <input
                          class="mr-4"
                          id="differentEmail"
                          type="radio"
                          value="differentEmail"
                          v-model="selectReceiptEmail"
                          @change="updateReceiptEmail()"
                        />
                        Send to a different email
                      </label>
                      <input
                        v-if="selectReceiptEmail === 'differentEmail'"
                        v-model="receiptEmail"
                        type="text"
                        required
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        title="E.g: johndoe@example.com"
                        placeholder="Email"
                        autocomplete="nope"
                      />
                      <button v-if="!isSendingReceipt" class="w-40" type="button" @click="sendReceipt()">
                        Send {{ payload.donation.type === 'Single' ? 'Receipt' : 'Confirmation' }}
                      </button>
                      <button v-if="isSendingReceipt" class="secondary w-40" type="button">
                        <img class="h-4" src="@/assets/img/spinning.svg" />
                      </button>
                    </div>

                    <!-- Text input for supporter doesn't have email -->
                    <div v-if="!payload.supporter.email" class="flex flex-row">
                      <input
                        v-model="receiptEmail"
                        type="text"
                        required
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        title="E.g: johndoe@example.com"
                        placeholder="Email"
                        autocomplete="nope"
                      />
                      <button v-if="!isSendingReceipt" class="w-40 ml-4" type="button" @click="sendReceipt()">
                        Send Receipt
                      </button>
                      <button v-if="isSendingReceipt" class="secondary w-40 ml-4" type="button">
                        <img class="h-4" src="@/assets/img/spinning.svg" />
                      </button>
                    </div>
                  </form>
                </div>
                <!-- End send receipt -->

                <div class="field mt-2" v-if="message"><alert :message="message"></alert></div>

                <div class="flex" v-if="transactionStatus === failed">
                  <img class="h-5 mr-2" src="@/assets/img/cross_icon.svg" />
                  Failed
                </div>
                <div
                  class="flex"
                  v-if="
                    transactionStatus === pending &&
                    (payload.paymentCaptureSystem === 'web' || payload.transaction.paymentType === 'direct-debit')
                  "
                >
                  <img class="h-5 mr-2" src="@/assets/img/process_icon.svg" />
                  Processing by bank
                </div>
                <div v-if="transactionStatus === pending && payload.paymentCaptureSystem === 'sms'" class="flex">
                  <img class="h-5 mr-2" src="@/assets/img/spinning.svg" />
                  Waiting for payment
                </div>
                <div v-if="transactionStatus === pending && payload.paymentCaptureSystem === 'sms'">
                  <button v-if="!isResending && !isResent" class="primary mt-2" type="button" @click="resendToken()">
                    Resend SMS
                  </button>
                  <h3 v-if="isResent">A payment message has been sent</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div v-if="payload.agentEmail" class="field">
              <label>Agent Email</label>
              <input type="text" disabled :value="payload.agentEmail" />
            </div>
            <div class="field">
              <label v-if="payload.donation.webId">Reference Number</label>
              <input v-if="payload.donation.webId" type="text" disabled :value="payload.donation.webId" />
            </div>
          </div>
        </div>

        <!-- Supporter -->
        <div class="field mt-6">
          <h2>Supporter</h2>
          <div class="row mt-2">
            <div class="w-1/4">
              <label>Title</label>
              <input type="text" disabled :value="payload.supporter.title" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>First Name</label>
              <input type="text" disabled :value="payload.supporter.firstName" />
            </div>
            <div class="field">
              <label>Last Name</label>
              <input type="text" disabled :value="payload.supporter.lastName" />
            </div>
          </div>
          <div v-if="payload.supporter.phoneNumber" class="row mt-2">
            <div class="field">
              <label>Phone Number</label>
              <input type="text" disabled :value="payload.supporter.phoneNumber" />
            </div>
          </div>
          <div v-if="payload.supporter.email" class="row mt-2">
            <div class="field">
              <label>Email</label>
              <input type="text" disabled :value="payload.supporter.email" />
            </div>
          </div>
          <div v-if="payload.supporter.businessName" class="row mt-2">
            <div class="field">
              <label>Business Name</label>
              <input type="text" disabled :value="payload.supporter.businessName" />
            </div>
          </div>
          <div v-if="payload.addressFullLine" class="row mt-2">
            <div class="field">
              <label>Address</label>
              <input type="text" disabled :value="payload.addressFullLine" />
            </div>
          </div>
        </div>

        <!-- Gift -->
        <div v-if="payload.donation.isGift" class="field mt-6">
          <h2>Gift Recipient</h2>
          <div class="row mt-2">
            <div class="w-1/4">
              <label>Title</label>
              <input type="text" disabled :value="payload.donation.gift.title" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>First Name</label>
              <input type="text" disabled :value="payload.donation.gift.firstName" />
            </div>
            <div class="field">
              <label>Last Name</label>
              <input type="text" disabled :value="payload.donation.gift.lastName" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>Address</label>
              <input type="text" disabled :value="giftAddress" />
            </div>
          </div>
        </div>

        <!-- Product -->
        <div class="field mt-6">
          <h2>Product</h2>
          <div class="row mt-2">
            <div class="field">
              <label>ID</label>
              <input type="text" disabled :value="payload.donationProductDetails.id" />
            </div>
            <div class="field">
              <label>Name</label>
              <input type="text" disabled :value="payload.donationProductDetails.productname" />
            </div>
          </div>
          <div class="row mt-2">
            <div v-if="payload.donationProductDetails.producttype" class="field">
              <label>Type</label>
              <input type="text" disabled :value="payload.donationProductDetails.producttype" />
            </div>
            <div class="field">
              <label>Appeal ID</label>
              <input type="text" disabled :value="payload.donation.appealId" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>Fund ID</label>
              <input type="text" disabled :value="payload.donation.fundId" />
            </div>
            <div class="field">
              <label>Campaign ID</label>
              <input type="text" disabled :value="payload.donation.campaignId" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="showButton">
        <div class="flex-grow"></div>
        <!-- <button type="button" @click="makeAnotherDonation()" v-if="canCreateDonation">Make another donation</button> -->
        <button type="button" @click="makeAnotherDonation()">Make another donation</button>
      </div>
    </form>
  </div>
</template>

<script>
import Alert from '@/components/Alert.vue';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'DonationDetailsModal',
  components: {
    Alert,
  },

  data() {
    return {
      completed: 'completed',
      failed: 'failed',
      pending: 'pending',
      donationInterval: null,
      transactionStatus: null,
      isResending: false,
      isResent: false,
      showResendReceiptInput: false,
      receiptEmail: null,
      message: null,
      isSendingReceipt: false,
      selectReceiptEmail: 'supporterEmail',
    };
  },
  props: {
    payload: Object,
    showButton: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      newDonationPayload: (state) => state.donationModal.payload,
    }),
    // canCreateDonation() {
    //   return this.$store.getters['auth/hasAccess'](MODULE.SUPPORTER, PERMISSION.CREATE);
    // },
    giftAddress() {
      if (this.payload.donation.isGiftAtSameAddress) {
        return this.payload.addressFullLine;
      } else {
        return `${
          this.payload.donation.giftAddress.unitnumber ? this.payload.donation.giftAddress.unitnumber + ', ' : ''
        }${this.payload.donation.giftAddress.streetno} ${this.payload.donation.giftAddress.streetname}, ${
          this.payload.donation.giftAddress.suburb
        } ${this.payload.donation.giftAddress.state} ${this.payload.donation.giftAddress.postcode}, ${
          this.payload.donation.giftAddress.country
        }`;
      }
    },
  },

  mounted() {
    this.transactionStatus = this.payload.transaction.status;
    if (this.transactionStatus === this.pending && this.payload.paymentCaptureSystem === 'sms') {
      this.donationInterval = setInterval(this.checkDonationStatus, 10000);
    }
    this.receiptEmail = this.payload.supporter.email;
  },

  methods: {
    close() {
      clearInterval(this.donationInterval);
      this.$emit('close');
    },
    async checkDonationStatus() {
      if (this.payload.donation) {
        const { payload } = await this.$store.dispatch('donationModal/getDonation', this.payload.donation.webId);
        if (payload.transaction.status && payload.transaction.status != 'pending') {
          this.transactionStatus = payload.transaction.status;
          this.payload.transaction = payload.transaction;
          this.receiptEmail = this.payload.supporter.email;
          // this.$store.dispatch('dotp/getAll');
          clearInterval(this.donationInterval);
        }
      }
    },
    async resendToken() {
      try {
        this.isResending = true;
        this.remotePaymentToken = await this.$store.dispatch('donationModal/resendToken', this.payload.donation.webId);
        this.isResent = true;
      } catch (err) {
        console.log(err);
      } finally {
        this.isResending = false;
      }
    },
    getPaymentType() {
      if (this.payload.transaction.paymentType === 'direct-debit') {
        return 'Direct Debit';
      }
      if (this.payload.paymentCaptureSystem === 'sms') {
        return 'Credit Card - SMS';
      }
      if (this.payload.transaction.paymentType === 'credit-card') {
        return 'Credit Card';
      }
      if (this.payload.transaction.paymentType === 'paypal') {
        return 'PayPal';
      }
    },
    formatDate(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    updateReceiptEmail() {
      if (this.selectReceiptEmail === 'differentEmail') {
        this.receiptEmail = null;
      }
      if (this.selectReceiptEmail === 'supporterEmail') {
        this.receiptEmail = this.payload.supporter.email;
      }
    },
    async sendReceipt() {
      try {
        this.isSendingReceipt = true;
        const isValid = document.querySelector('#send-receipt').reportValidity();
        if (isValid) {
          await this.$store.dispatch('donationModal/sendReceiptEmail', {
            email: this.receiptEmail,
            firstName: this.payload.supporter.firstName,
            lastName: this.payload.supporter.lastName,
            businessName: this.payload.donation.businessName,
            donationAmount: this.payload.donation.amount,
            receiptNumber: this.payload.transaction.receiptNumber,
            transactionDate: this.payload.transaction.webGiftDate,
            donationType: this.payload.donation.type,
          });
          this.message = {
            content: `Receipt #${this.payload.transaction.receiptNumber} has been sent to ${this.receiptEmail}`,
            type: 'success',
          };
          this.showResendReceiptInput = false;
          this.receiptEmail = null;
          this.selectReceiptEmail = 'supporterEmail';
        }
      } catch (err) {
        console.log(err);
        this.message = {
          content: 'Cannot send email',
          type: 'error',
        };
      } finally {
        this.isSendingReceipt = false;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.donationInterval);
  },
};
</script>

<style>
.dollar-handle {
  @apply min-w-1/5 max-w-1/5;
}
</style>
